const getStarted = {
    getStarted: {
      pageTitle: 'Get Started',
      pageDescription: 'Use the IOPS Ground Station to communicate with satellites and to downlink data.',
  
      button: {
        tutorial: 'Tutorial'
      },
  
      step: {
        1: {
          title: 'Manage Spacecraft',
          subtitle: 'STEP 1',
          description: 'Check and access to the\nregistered spacecraft'
        },
        2: {
          title: 'Contact Profile',
          subtitle: 'STEP 2',
          description: 'Define contact configuration. Manage where data will move during contact.'
        },
        3: {
          title: 'Schedule a Contact',
          subtitle: 'STEP 3',
          description: 'Schedule satellite access time to communicate with the spacecraft at the ground station.'
        }
      }
    }
  };

export default getStarted;